import React from "react"
import {FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";

const debug = false
// const debug = "FieldPopover_Editable"

type State = {
    initialPropsValue   : any
    currentValue        : any
    showPopover         : boolean
}

export default class FieldPopover_Editable extends React.Component<FieldEditableProps,State> {

    public previousValue        : any

    public static defaultProps  = {
        size        : FieldViewSize.DEFAULT
    }

    constructor(props:FieldEditableProps) {
        super(props);

        const value = props.field.getViewValue(props.model)

        debug && console.log(debug,"constructor initValue=", value)

        this.state = {
            initialPropsValue: value, // required to check if currentOption update needed on props changed
            currentValue: value,
            showPopover: false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {

        // const newValue = props.model[props.field.fieldId]
        const newValue = props.field.getViewValue(props.model)

        debug && console.log(debug, "getDerivedStateFromProps newValue=", newValue)

        if (newValue !== state.initialPropsValue) {

            debug && console.log(debug, "props have changed - apply to state and set initialPropsValue")

            return {
                initialPropsValue   : newValue,
                currentValue        : newValue
            }
        }
        return null
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}


    onValueChange = (value:any, hidePopover: boolean = true) => {

        debug && console.log(debug, "onValueChange", value)

        this.previousValue  = this.state.currentValue;
        const newValue      = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {

            if (this.props.onChange) {
                // @ts-ignore
                this.props.onChange(newValue, this.onCancelChange);
            }
            if (hidePopover) this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    render() {

        debug && console.log(debug, "render() size=",this.props.size, this.state)

        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        // need check value because of none
        if (this.state.currentValue && (!Array.isArray(this.state.currentValue) || !_.isEmpty(this.state.currentValue))) {
            return (
                <field.components.InlineValueNotEmpty size      = {this.props.size}
                                                      className = {classes}
                                                      field     = {this.props.field}
                                                      value     = {this.state.currentValue}
                                                      options   = {this.props.options}
                                                      disabled  = {this.props.disabled}
                                                      onClick   = {this.showPopover}
                                                      onChange  = {this.onValueChange}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} value={this.state.currentValue} />}
                </field.components.InlineValueNotEmpty>
            );
        } else {
            return (
                <field.components.InlineValueEmpty size={this.props.size} className={classes} field={this.props.field} disabled={this.props.disabled} onClick={this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </field.components.InlineValueEmpty>
            );
        }
    }
}
